import React from 'react'
import { useTranslation, Trans } from 'i18n'
import { Formik, Field } from 'formik'
import { TurnstileWidget } from 'components/TurnstileWidget'
import { renderTextInput2 } from 'components/forms/SharedInputs'
import * as Yup from 'yup'
import Checkbox from '@mui/material/Checkbox'
import './SetReminderView.scss'
import ReceiptViewHeader from './ReceiptViewHeader'

export const SetReminderView = ({
  onRequestReminder,
  onHaveReceiptClick,
  headline = 'Set reminder',
  bodyCopy = '',
  introCopy,
}) => {
  const { t } = useTranslation(['ugcMediaUpload', 'common'])
  let validationSchema = {
    email: Yup.string()
      .email(t('validation.invalidEmail'))
      .required(t('validation.required')),
    confirmation: Yup.bool().oneOf([true], t('validation.requiredField')),
    //confirmation2: Yup.string().required("Please confirm you agree with our Terms & Conditions and Privacy Policy."),
  }
  const initialValues = {
    // formRewardOptions: formRewardOptions[0].value,
    email: '',
    confirmation: false,
  }

  const handleReminderSubmission = async values => {
    const { email, turnstileToken } = values
    onRequestReminder(email, turnstileToken)
  }
  const isTheFormValid = (errors, dirty) => {
    return errors.length === 0 && dirty === true
  }
  return (
    <div className="receipt-view set-reminder-view">
      <ReceiptViewHeader headline={headline} introCopy={introCopy} />

      <div className={`receipt-view-content`}>
        <div className="reminder-body-copy" dangerouslySetInnerHTML={{ __html: bodyCopy }}></div>
        <Formik
          className={`reminder-formik`}
          key={`reminder-formik`}
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={Yup.object(validationSchema)}
          initialValues={initialValues}
          onSubmit={values => {
            handleReminderSubmission(values)
          }}
        >
          {props => {
            const {
              handleSubmit,
              errors,
              values,
              touched,
              setFieldValue,
              dirty,
              isValid,
            } = props
            return (
              <form
                autoComplete={'on'}
                className={`receipt-reminder-form`}
                onSubmit={handleSubmit}
              >
                <TurnstileWidget
                  mode="invisible"
                  onToken={token =>
                    setFieldValue('turnstileToken', token)
                  }
                />
                <ul className="form__elements">
                  <li className="form__element">
                    <Field
                      name={`email`}
                      autoComplete={'on'}
                      type="email"
                      component={renderTextInput2}
                      variant="filled"
                      label={t('ugcMediaUpload:reminder.emailLabel')}
                      placeholder={t(
                        'ugcMediaUpload:reminder.emailPlaceholder',
                      )}
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </li>
                  <li className="form__element checkbox-row">
                    <div className="input-row">
                      <Field
                        type="checkbox"
                        defaultChecked={false}
                        value={values.confirmation}
                        component={Checkbox}
                        name="confirmation"
                        error={errors.confirmation}
                        touched={touched.confirmation && true ? 'true' : ''}
                        onChange={e => {
                          console.log(e.target.value)
                          setFieldValue('confirmation', e.target.checked)
                        }}
                      />
                      <label htmlFor="confirmation">
                        <Trans
                          t={t}
                          i18nKey="ugcMediaUpload:reminder.legalConsent"
                          components={{
                            terms: (
                              <a
                                href="https://www.dailybreak.com/terms"
                                target="_blank"
                              />
                            ),
                            privacy: (
                              <a
                                href="https://www.dailybreak.com/privacy"
                                target="_blank"
                              />
                            ),
                          }}
                        />
                      </label>
                    </div>
                    {errors.confirmation && (
                      <p className="error">{errors.confirmation}</p>
                    )}
                  </li>

                  <li className="form__submit-wrapper">
                    <div className={`receipt-button-container`}>
                      <button
                        className="btn themed-button-secondary"
                        type="button"
                        onClick={() => onHaveReceiptClick()}
                      >
                        {t('ugcMediaUpload:reminder.haveSubmissionCta')}
                      </button>
                      <input
                        className="btn themed-button"
                        type="submit"
                        value={t('common:submit')}
                      />
                    </div>
                  </li>
                </ul>
              </form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}
